import { gql } from '@apollo/client';

/**
 * 审核池运营处理（api-server 转发 → pickup 本地事务）。对应 PickupReviewPoolMutation。
 * 站点本体的建/改由既有 saveCooperationWarehouse 完成，本组 mutation 负责回填解卡 + 建联状态 + mark processed。
 */

export const RESOLVE_REVIEW_POOL_AS_NEW_STATION = gql`
  mutation ResolveReviewPoolAsNewStation($input: ResolveReviewPoolNewStationInput!) {
    resolveReviewPoolAsNewStation(input: $input)
  }
`;

export const RESOLVE_REVIEW_POOL_AS_AB_MAPPING = gql`
  mutation ResolveReviewPoolAsAbMapping($input: ResolveReviewPoolAbMappingInput!) {
    resolveReviewPoolAsAbMapping(input: $input)
  }
`;

export const RESOLVE_REVIEW_POOL_AS_MERGE_TO_EXISTING = gql`
  mutation ResolveReviewPoolAsMergeToExisting($input: ResolveReviewPoolMergeInput!) {
    resolveReviewPoolAsMergeToExisting(input: $input)
  }
`;

export const RESOLVE_REVIEW_POOL_AS_UPDATE_EXISTING = gql`
  mutation ResolveReviewPoolAsUpdateExisting($input: ResolveReviewPoolExistingStationInput!) {
    resolveReviewPoolAsUpdateExisting(input: $input)
  }
`;

export const RESOLVE_REVIEW_POOL_AS_CONFIRM_APPOINTMENT = gql`
  mutation ResolveReviewPoolAsConfirmAppointment($input: ResolveReviewPoolExistingStationInput!) {
    resolveReviewPoolAsConfirmAppointment(input: $input)
  }
`;

/** 改地址重诊断（标准化失败分支 #1）：后端标准化实际地址→更新条目地址+hash+坐标+诊断，前端重查得新诊断。 */
export const UPDATE_REVIEW_POOL_ADDRESS = gql`
  mutation UpdateReviewPoolAddress($input: UpdateReviewPoolAddressInput!) {
    updateReviewPoolAddress(input: $input)
  }
`;

export interface UpdateReviewPoolAddressInput {
  reviewPoolId: number;
  warehouseId: number;
  addressLine1: string;
  city: string;
  state: string;
  zipcode: string;
  addressLine2?: string | null;
}

export interface UpdateReviewPoolAddressResponse {
  updateReviewPoolAddress: boolean;
}

export interface ResolveReviewPoolNewStationInput {
  reviewPoolId: number;
  cooperationWarehouseId: number;
  /** 初始建联状态：4已建联 / 1待上门 */
  linkStatus?: number | null;
  /** 首次建联（电联1）联络记录截图 S3 key JSON（可空） */
  proofS3KeysJson?: string | null;
}

export interface AbMappingDimension {
  contactName?: string | null;
  contactPhone?: string | null;
  channelId?: number | null;
}

export interface ResolveReviewPoolAbMappingInput {
  reviewPoolId: number;
  targetBCooperationWarehouseId: number;
  /** AB 映射维度列表（每组=联系人+联系方式+渠道，可多组映射到同一主站点） */
  mappings: AbMappingDimension[];
  fullySelected?: boolean;
}

export interface ResolveReviewPoolMergeInput {
  reviewPoolId: number;
  targetCooperationWarehouseId: number;
}

export interface ResolveReviewPoolExistingStationInput {
  reviewPoolId: number;
  targetCooperationWarehouseId: number;
  /**
   * 联络记录截图 S3 keys。两种形态：
   * - JSON 数组字符串 `["k1","k2"]`：首次建联(电联1)凭证，「确认/创建当日预约单」用
   * - 2.1 分组对象 `{"first":[...],"second":[...]}`：标准化失败免上门流程用，
   *   后端据此拆成 op3(首次建联) + op6(二次建联) 两条跟进记录，需求点6 的时间线才有分阶段凭证
   */
  proofS3KeysJson?: string;
  /**
   * 目标建联状态（2.1 需求点1）。仅「标准化失败 + 两次电联均未联系到 → 更新原站点为
   * 确认无法建联(5)」时传 5，其余场景不传（后端保持原状态不动，行为同 2.0）。
   * 后端会断言该条目 diagnosis_type=2 才放行。
   */
  linkStatus?: number;
}

export interface ResolveReviewPoolAsNewStationResponse {
  resolveReviewPoolAsNewStation: boolean;
}
export interface ResolveReviewPoolAsAbMappingResponse {
  resolveReviewPoolAsAbMapping: boolean;
}
export interface ResolveReviewPoolAsMergeToExistingResponse {
  resolveReviewPoolAsMergeToExisting: boolean;
}
export interface ResolveReviewPoolAsUpdateExistingResponse {
  resolveReviewPoolAsUpdateExisting: boolean;
}
export interface ResolveReviewPoolAsConfirmAppointmentResponse {
  resolveReviewPoolAsConfirmAppointment: boolean;
}
